import React from 'react'

export const TopNavLogo = React.memo(() => {
  return (
    <>
      <img
        src="https://www.paypalobjects.com/paypal-ui/logos/svg/paypal-mark-color.svg"
        alt="paypal-logo"
        className="paypal-logo-width"
      />
    </>
  )
})
